<div class="max-w-6xl mx-auto p-2 md:p-4">
  <!-- Header -->
  <div class="mb-8">
    <h2 class="text-2xl md:text-3xl font-semibold text-gray-900 m-0 mb-2 flex items-center" i18n>
      Customer Lookup
    </h2>
    <p class="text-gray-600 m-0 text-base" i18n>Check the availability of a customer</p>
  </div>

  <!-- No Products Warning Message -->
  <div *ngIf="!loadingProducts && productOptions.length === 0" class="mb-4">
    <p-card styleClass="border-amber-300 bg-amber-50">
      <div class="flex items-start gap-3">
        <i class="pi pi-exclamation-triangle text-amber-600 text-2xl flex-shrink-0 mt-0.5"></i>
        <div class="flex-1">
          <p class="m-0 text-amber-900 font-semibold text-base mb-1" i18n>No Products Assigned</p>
          <p class="m-0 text-amber-800 text-sm leading-relaxed" i18n>
            No Products have been set up yet for your company. Please make sure products are available and assigned to you before proceed with customer lookup
          </p>
        </div>
      </div>
    </p-card>
  </div>

  <!-- Product Selection - Hidden but still auto-selected -->
  <!-- <p-card [header]="'Product Selection'" i18n-header class="mb-3 md:p-4">
    <div>
      <label for="products" class="block font-medium mb-2 text-gray-900 after:content-['_*'] after:text-red-500" i18n>
        <i class="pi pi-box mr-2"></i>Select Products
      </label>
      <div class="relative">
        <p-multiSelect id="products" [(ngModel)]="selectedProducts" [options]="productOptions" optionLabel="label" optionValue="value" placeholder="Select products" i18n-placeholder [showClear]="true" [disabled]="loadingProducts" class="w-full">
        </p-multiSelect>
        <div *ngIf="loadingProducts" class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 rounded">
          <p-progressSpinner [style]="{'width': '24px', 'height': '24px'}" strokeWidth="4"></p-progressSpinner>
        </div>
      </div>
      <small class="mt-2 flex items-center gap-1 flex-row block mt-1 text-gray-600 text-sm" i18n>
        <i class="pi pi-info-circle mr-1"></i>
        Select one or more products to check availability for this customer
      </small>
    </div>
  </p-card> -->

  <p-card [header]="'Lookup Method'" i18n-header class="mb-3 md:p-4">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
      <div>
        <label for="lookupMode" class="block font-medium mb-2 text-gray-900" i18n>
          <i class="pi pi-compass mr-2"></i>Select Lookup Method
        </label>
        <p-select id="lookupMode"
                  [(ngModel)]="lookupMode"
                  [options]="lookupModes"
                  optionLabel="label"
                  optionValue="value"
                  (onChange)="onLookupModeChange($event.value)"
                  class="w-full">
        </p-select>
      </div>
      <small class="text-gray-600 text-sm leading-6 block" i18n>
        <i class="pi pi-info-circle mr-1"></i>
        Choose between Google search, manual address, or drawing a geofence to ensure no other FSR approaches the same customer.
      </small>
    </div>
  </p-card>

  <div *ngIf="lookupMode === 'GOOGLE'" class="space-y-3">
    <p-card [header]="'Search Customer'" i18n-header class="md:p-4">
      <div>
        <div class="relative">
          <label for="businessSearch" class="block font-medium mb-2 text-gray-900" i18n>
            <i class="pi pi-building mr-2"></i>Search Customer / Business / Place
          </label>
          <input #businessInput
                 id="businessSearch"
                 type="text"
                 pInputText
                 [(ngModel)]="searchQuery"
                 (input)="searchBusiness({query: searchQuery})"
                 placeholder="Search customer/business/place..."
                 i18n-placeholder
                 class="w-full" />

          <div *ngIf="businessSuggestions.length > 0"
               class="suggestions-dropdown absolute z-50 w-full max-h-72 overflow-y-auto bg-white border border-gray-200 rounded-md mt-1 shadow-lg"
               data-suggestions="business">
            <div *ngFor="let suggestion of businessSuggestions"
                 class="px-4 py-3 cursor-pointer border-b border-gray-200 transition-colors duration-150 hover:bg-gray-50 last:border-b-0"
                 (mousedown)="onBusinessSelect(suggestion)">
              <div class="font-medium text-gray-900 mb-1">
                {{suggestion.structured_formatting?.main_text || suggestion.description}}
              </div>
              <div class="text-sm text-gray-600" *ngIf="suggestion.structured_formatting?.secondary_text">
                {{suggestion.structured_formatting?.secondary_text}}
              </div>
            </div>
          </div>
          <small class="block mt-1 text-gray-600 text-sm" i18n>
            <i class="pi pi-info-circle mr-1"></i>
            Type at least 3 characters to search businesses using Google Places
          </small>
        </div>

        <div class="flex gap-3 items-center mt-4 flex-wrap">
          <p-button label="Search Business"
                    icon="pi pi-search"
                    (onClick)="performBusinessSearch()"
                    [loading]="loading"
                    [disabled]="!searchQuery || loadingProducts"
                    i18n-label>
          </p-button>
        </div>
      </div>
    </p-card>
  </div>

  <div *ngIf="lookupMode === 'MANUAL_ADDRESS'" class="space-y-3">
    <p-card [header]="'Manual Address Lookup'" i18n-header class="md:p-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label for="country" class="block font-medium mb-2 text-gray-900 after:content-['_*'] after:text-red-500" i18n>
              <i class="pi pi-globe mr-2"></i>Country
            </label>
          <p-select id="country"
                    [(ngModel)]="selectedCountry"
                    [options]="countryOptions"
                    optionLabel="label"
                    placeholder="Select country"
                    i18n-placeholder
                    (onChange)="onCountryChange()"
                    class="w-full">
            </p-select>
          </div>

          <div class="relative">
            <label for="city" class="block font-medium mb-2 text-gray-900 after:content-['_*'] after:text-red-500" i18n>
              <i class="pi pi-map-marker mr-2"></i>Town/City
            </label>
          <input id="city"
                 type="text"
                 pInputText
                 [(ngModel)]="city"
                 (input)="onCityChange()"
                 (focus)="showCitySuggestions = true"
                 placeholder="Enter town or city"
                 i18n-placeholder
                 class="w-full" />

          <div *ngIf="showCitySuggestions && citySuggestions.length > 0"
               class="suggestions-dropdown absolute z-50 w-full max-h-48 overflow-y-auto bg-white border border-gray-200 rounded-md mt-1 shadow-lg"
               data-suggestions="city">
            <div *ngFor="let cityName of citySuggestions"
                 class="px-4 py-3 cursor-pointer border-b border-gray-200 transition-colors duration-150 hover:bg-gray-50 last:border-b-0"
                 (mousedown)="selectCity(cityName)">
                {{cityName}}
              </div>
            </div>
          </div>

          <div class="md:col-span-2 relative">
            <label for="streetAddress" class="block font-medium mb-2 text-gray-900 after:content-['_*'] after:text-red-500" i18n>
              <i class="pi pi-home mr-2"></i>Street Address
            </label>
          <input id="streetAddress"
                 type="text"
                 pInputText
                 [(ngModel)]="streetAddress"
                 (focus)="showStreetSuggestions = true"
                 placeholder="Enter street address"
                 i18n-placeholder
                 class="w-full" />

          <div *ngIf="showStreetSuggestions && streetSuggestions.length > 0"
               class="suggestions-dropdown absolute z-50 w-full max-h-48 overflow-y-auto bg-white border border-gray-200 rounded-md mt-1 shadow-lg"
               data-suggestions="street">
            <div *ngFor="let streetName of streetSuggestions"
                 class="px-4 py-3 cursor-pointer border-b border-gray-200 transition-colors duration-150 hover:bg-gray-50 last:border-b-0"
                 (mousedown)="selectStreet(streetName)">
                {{streetName}}
              </div>
            </div>
          </div>

        <div class="md:col-span-2">
          <label for="placeName" class="block font-medium mb-2 text-gray-900" i18n>
            <i class="pi pi-flag mr-2"></i>Place Name / Label (Optional)
          </label>
          <input id="placeName"
                 type="text"
                 pInputText
                 [(ngModel)]="manualPlaceName"
                 placeholder="e.g. Private Residence - North Gate"
                 i18n-placeholder
                 class="w-full" />
        </div>

        <div>
          <label for="addressLine2" class="block font-medium mb-2 text-gray-900" i18n>
            <i class="pi pi-building mr-2"></i>Address Line 2 (Optional)
          </label>
          <input id="addressLine2"
                 type="text"
                 pInputText
                 [(ngModel)]="addressLine2"
                 placeholder="Apartment, suite, etc."
                 i18n-placeholder
                 class="w-full" />
        </div>

        <div>
          <label for="stateRegion" class="block font-medium mb-2 text-gray-900" i18n>
            <i class="pi pi-map mr-2"></i>State / Region (Optional)
          </label>
          <input id="stateRegion"
                 type="text"
                 pInputText
                 [(ngModel)]="stateRegion"
                 placeholder="Enter state or region"
                 i18n-placeholder
                 class="w-full" />
        </div>

        <div>
          <label for="postalCode" class="block font-medium mb-2 text-gray-900" i18n>
            <i class="pi pi-envelope mr-2"></i>Postal Code (Optional)
          </label>
          <input id="postalCode"
                 type="text"
                 pInputText
                 [(ngModel)]="postalCode"
                 placeholder="Enter postal code"
                 i18n-placeholder
                 class="w-full" />
        </div>

        <div class="md:col-span-2 flex gap-3 items-center mt-2 flex-wrap">
          <p-button label="Locate Address"
                    icon="pi pi-map-marker"
                    (onClick)="checkAddress()"
                    [loading]="loading"
                    [disabled]="!selectedCountry || !city || !streetAddress || loadingProducts"
                    i18n-label>
          </p-button>
          <small class="text-gray-600 text-sm flex items-center gap-1" i18n>
            <i class="pi pi-info-circle"></i>
            We will geocode the address and let you fine-tune the marker before running the lookup.
          </small>
        </div>
      </div>

      <div class="mt-5" *ngIf="manualAddressReady">
        <div class="flex justify-between items-center mb-2">
          <h5 class="m-0 text-gray-900 font-semibold flex items-center gap-2" i18n>
            <i class="pi pi-map-marker text-blue-500"></i>Verify Location
          </h5>
          <span class="text-sm text-gray-600">
            {{manualGeocodedLocation?.lat | number:'1.6-6'}}, {{manualGeocodedLocation?.lng | number:'1.6-6'}}
          </span>
        </div>
        <div #manualAddressMap class="w-full h-64 rounded-lg border border-gray-200 overflow-hidden"></div>
        <small class="block mt-2 text-gray-600 text-sm" i18n>
          Drag the marker if needed to match the precise customer location.
        </small>
        <div class="mt-2 text-xs text-blue-600 font-mono break-all flex items-center gap-2"
             *ngIf="manualAddressPlaceId">
          <i class="pi pi-google"></i>
          <span i18n>Linked Google Place ID:</span>
          <span class="truncate">{{manualAddressPlaceId}}</span>
          <p-button size="small"
                    icon="pi pi-copy"
                    [text]="true"
                    (onClick)="copyToClipboard(manualAddressPlaceId)"
                    [pTooltip]="'Copy Place ID'"
                    tooltipPosition="top"
                    i18n-pTooltip>
          </p-button>
        </div>
        <div class="mt-4" *ngIf="manualAddressMatchesLoading">
          <i class="pi pi-spin pi-spinner mr-2"></i>
          <span i18n>Searching for nearby matches…</span>
        </div>
        <div class="mt-4" *ngIf="!manualAddressMatchesLoading && manualAddressMatches.length > 0">
          <h6 class="m-0 mb-2 text-gray-800 font-semibold flex items-center gap-2" i18n>
            <i class="pi pi-search text-blue-500"></i>Possible Matches
          </h6>
          <p class="text-xs text-gray-500 mb-3" i18n>Select a result to reuse an existing location and avoid duplicates.</p>
          <div class="flex flex-col gap-2">
            <div *ngFor="let candidate of manualAddressMatches"
                 class="p-3 border border-gray-200 rounded-lg bg-white shadow-sm flex flex-col md:flex-row md:items-center md:justify-between gap-3">
              <div>
                <div class="text-sm font-semibold text-gray-900">
                  {{candidate.name || candidate.formattedAddress || ('Unnamed Location' | uppercase)}}
                </div>
                <div class="text-xs text-gray-600" *ngIf="candidate.formattedAddress && candidate.name">
                  {{candidate.formattedAddress}}
                </div>
                <div class="text-xs text-gray-600" *ngIf="candidate.distanceMeters">
                  <i class="pi pi-compass mr-1"></i>{{candidate.distanceMeters | number:'1.0-0'}} m away
                </div>
                <div class="text-xs text-gray-500 font-mono break-all" *ngIf="candidate.placeId">
                  <i class="pi pi-google mr-1 text-blue-500"></i>{{candidate.placeId}}
                </div>
              </div>
              <p-button size="small"
                        [outlined]="manualAddressSelectedCandidate?.id !== candidate.id"
                        [label]="manualAddressSelectedCandidate?.id === candidate.id ? ('Selected' | uppercase) : ('Use This Location' | uppercase)"
                        (onClick)="selectManualAddressCandidate(candidate)">
              </p-button>
            </div>
          </div>
          <p-paginator [rows]="manualAddressMatchesPageSize"
                       [totalRecords]="manualAddressMatchesTotal"
                       [rowsPerPageOptions]="[5,10,20]"
                       (onPageChange)="onManualAddressPageChange($event)"
                       class="mt-3">
          </p-paginator>
        </div>
        <div class="mt-3 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3"
             *ngIf="manualAddressConflicts.length > 0">
          <i class="pi pi-exclamation-triangle mr-2"></i>
          <span i18n>A customer already exists near this address. Please confirm you are updating the same location.</span>
        </div>
        <div class="flex gap-3 items-center mt-4 flex-wrap">
          <p-button label="Lookup Manual Address"
                    icon="pi pi-search"
                    (onClick)="performManualAddressLookup()"
                    [loading]="loading"
                    [disabled]="!manualAddressReady || loading"
                    i18n-label>
            </p-button>
        </div>
      </div>
    </p-card>
  </div>

  <div *ngIf="lookupMode === 'MANUAL_GEOFENCE'" class="space-y-3">
    <p-card [header]="'Manual Geofence Reservation'" i18n-header class="md:p-4">
      <div class="space-y-5">
        <div class="text-sm text-gray-700 bg-blue-50 border border-blue-200 rounded-lg p-3">
          <i class="pi pi-info-circle mr-2 text-blue-500"></i>
          <span i18n>Click on the map to drop the center point and adjust the radius to cover the entire customer area. This reservation blocks other FSRs within the circle.</span>
        </div>

        <div class="flex flex-wrap items-end gap-3">
          <div class="flex-1 min-w-[220px]">
            <label for="geoSearch" class="block font-medium mb-2 text-gray-900" i18n>
              <i class="pi pi-search mr-2"></i>Search Map
            </label>
            <input id="geoSearch"
                   type="text"
                   pInputText
                   [(ngModel)]="manualGeofenceSearchQuery"
                   (keydown.enter)="searchMapBusinesses(manualGeofenceSearchQuery)"
                   placeholder="Search for a place or address"
                   i18n-placeholder
                   class="w-full" />
          </div>
          <p-button label="Search"
                    icon="pi pi-search"
                    (onClick)="searchMapBusinesses(manualGeofenceSearchQuery)"
                    [loading]="manualGeofenceSearchLoading"
                    [disabled]="!manualGeofenceSearchQuery || manualGeofenceSearchQuery.trim().length < 3"
                    i18n-label>
          </p-button>
          <p-button severity="secondary"
                    label="My Location"
                    icon="pi pi-crosshair"
                    (onClick)="centerOnCurrentLocation()"
                    i18n-label>
          </p-button>
        </div>

        <div *ngIf="mapBusinessSuggestions.length > 0" class="border border-gray-200 rounded-lg bg-white shadow-sm">
          <div class="max-h-60 overflow-y-auto divide-y divide-gray-100">
            <div *ngFor="let suggestion of mapBusinessSuggestions"
                 class="p-3 hover:bg-gray-50 cursor-pointer flex flex-col gap-1"
                 (click)="selectMapBusiness(suggestion)">
              <span class="text-sm font-semibold text-gray-800">{{suggestion.name || suggestion.description}}</span>
              <span class="text-xs text-gray-500" *ngIf="suggestion.formatted_address">{{suggestion.formatted_address}}</span>
              <span class="text-xs text-blue-600 font-mono break-all" *ngIf="suggestion.place_id">
                <i class="pi pi-google mr-1"></i>{{suggestion.place_id}}
              </span>
            </div>
          </div>
        </div>

        <div class="w-full h-72 rounded-lg border border-gray-200 overflow-hidden">
          <div #manualGeofenceMap class="w-full h-full"></div>
        </div>

        <div class="text-xs text-gray-500" *ngIf="territoryBoundaries.length > 0">
          <i class="pi pi-map mr-1"></i>
          <span i18n>Territory boundaries are highlighted on the map. Pins can only be placed inside your assigned territories.</span>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
          <div>
            <label for="geofenceRadius" class="block font-medium mb-2 text-gray-900" i18n>
              <i class="pi pi-circle mr-2"></i>Radius (meters)
            </label>
            <input id="geofenceRadius"
                   type="range"
                   min="3"
                   max="250"
                   step="10"
                   [(ngModel)]="manualGeofenceRadius"
                   (ngModelChange)="onGeofenceRadiusChange($event)"
                   (mousedown)="onGeofenceRadiusInputStart()"
                   (mouseup)="onGeofenceRadiusInputEnd()"
                   (touchstart)="onGeofenceRadiusInputStart()"
                   (touchend)="onGeofenceRadiusInputEnd()"
                   class="w-full accent-blue-500" />
            <div class="mt-2 text-sm text-gray-600">
              {{manualGeofenceRadius}} <span i18n>meters</span>
            </div>
          </div>

          <div>
            <label for="geofenceLabel" class="block font-medium mb-2 text-gray-900" i18n>
              <i class="pi pi-tag mr-2"></i>Label (Optional)
            </label>
            <input id="geofenceLabel"
                   type="text"
                   pInputText
                   [(ngModel)]="manualGeofenceLabel"
                   placeholder="Private residence, building name, etc."
                   i18n-placeholder
                   class="w-full" />
          </div>
        </div>

        <div class="text-sm text-gray-600" *ngIf="manualGeofenceCenter">
          <i class="pi pi-map-marker mr-2 text-blue-500"></i>
          {{manualGeofenceCenter.lat | number:'1.6-6'}}, {{manualGeofenceCenter.lng | number:'1.6-6'}}
        </div>

        <div class="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3"
             *ngIf="manualGeofenceConflicts.length > 0">
          <div class="flex items-start gap-2">
            <i class="pi pi-exclamation-triangle mt-0.5"></i>
            <div>
              <div i18n>Google listings already exist within this radius. Consider linking to the existing customer.</div>
              <ul class="mt-2 list-disc list-inside space-y-1 text-xs text-amber-800">
                <li *ngFor="let conflict of manualGeofenceConflicts | slice:0:3">
                  {{conflict.name || conflict.formattedAddress || conflict.placeId}}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="flex gap-3 items-center flex-wrap">
          <p-button label="Lookup Geofence"
                    icon="pi pi-search"
                    (onClick)="performManualGeofenceLookup()"
                    [loading]="loading"
                    [disabled]="!manualGeofenceCenter || loadingProducts"
                    i18n-label>
          </p-button>
          <small class="text-gray-600 text-sm flex items-center gap-1">
            <i class="pi pi-info-circle"></i>
            <span i18n>Ensure you select products first and set the circle center.</span>
          </small>
        </div>
      </div>
    </p-card>
  </div>
  <!-- Address Search Results -->
  <div *ngIf="lookupMode === 'GOOGLE' && showAddressBusinessResults && addressBusinessResults.length > 0" class="mb-3 mt-3">
    <p-card [header]="'Businesses Found in This Area'" i18n-header class="border border-gray-200 md:p-4">
      <div class="flex flex-wrap justify-between items-center mb-4">
        <span class="font-medium text-gray-900" i18n>
          {{addressBusinessResults.length}} business{{addressBusinessResults.length === 1 ? '' : 'es'}} found
        </span>
        <small class="text-gray-600 text-sm" i18n>
          <i class="pi pi-info-circle mr-1"></i>
          Select a business to perform customer lookup
        </small>
      </div>

      <hr class="my-3">

      <div>
        <div *ngFor="let business of addressBusinessResults" class="flex justify-between items-center p-4 border border-gray-200 rounded-lg mb-3 cursor-pointer transition-all duration-150 hover:border-blue-500 hover:bg-gray-50 hover:-translate-y-0.5 hover:shadow-md" (click)="selectAddressBusiness(business)">
          <div class="flex-1">
            <h4 class="m-0 mb-2 text-gray-900 text-lg font-semibold flex items-center">
              <i class="pi pi-building mr-2"></i>
              {{business.name}}
            </h4>
            <div class="text-sm text-gray-600 mb-2 flex items-start">
              <i class="pi pi-map-marker mr-2"></i>
              {{business.formatted_address}}
            </div>
            <div *ngIf="business.types && business.types.length > 0">
              <small>
                <span *ngFor="let type of business.types.slice(0, 3)" class="inline-block bg-gray-100 text-gray-600 px-2 py-1 rounded text-xs mr-2 mb-1">
                  {{type}}
                </span>
              </small>
            </div>
          </div>
          <div class="text-blue-500 text-xl ml-4">
            <i class="pi pi-arrow-right"></i>
          </div>
        </div>
      </div>
    </p-card>
  </div>

  <!-- Interactive Map Section -->
  <!-- <p-card header="Interactive Map Search" styleClass="mb-3">
    <div class="map-section">
      <div class="map-container">
        <div id="map" class="google-map"></div>
        <div class="map-overlay">
          <div class="map-search-box">
            <input type="text" pInputText [(ngModel)]="mapSearchQuery" placeholder="Search for businesses on the map..." (input)="searchMapBusinesses($event)" class="w-full" i18n-placeholder />
            <div *ngIf="mapBusinessSuggestions.length > 0" class="map-suggestions-dropdown">
              <div *ngFor="let business of mapBusinessSuggestions" class="map-suggestion-item" (click)="selectMapBusiness(business)">
                <div class="business-name">{{business.name}}</div>
                <div class="business-address">{{business.formatted_address}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="map-instructions">
        <small class="field-hint">
          <i class="pi pi-info-circle mr-1"></i>
          Use the map to search and select businesses visually. Click on markers to see business details.
        </small>
      </div>
    </div>
  </p-card> -->

  <!-- Action Buttons -->
  <div class="flex gap-3 pt-3 md:mt-0 mb-3 flex-wrap">
    <p-button label="Clear Results" icon="pi pi-times" severity="secondary" (onClick)="clearResults()" [disabled]="lookupResults.length === 0" i18n-label>
    </p-button>
    <p-button appGlobalLoadingDisable label="Reset Search" icon="pi pi-refresh" severity="info" (onClick)="resetSearch()" i18n-label>
    </p-button>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="loading">
    <p-card>
      <div class="flex items-center justify-center p-8">
        <i class="pi pi-spin pi-spinner text-3xl"></i>
        <span class="ml-3 text-base text-gray-900" i18n>Searching...</span>
      </div>
    </p-card>
  </div>

  <!-- Results Section -->
  <div *ngIf="lookupResults.length > 0 && !loading">
    <p-card [header]="'Lookup Results'" i18n-header class="border border-gray-200 md:p-4">
      <div class="flex justify-between items-center mb-4">
        <span class="font-medium text-gray-900" i18n>
          {{lookupResults.length}} result{{lookupResults.length === 1 ? '' : 's'}} found
        </span>
      </div>

      <hr class="my-3">

      <div>
        <div *ngFor="let result of lookupResults; let i = index" class="py-4 mb-4 border-b border-gray-200 last:border-b-0 last:mb-0">

          <!-- Customer Info -->
          <div class="mb-4">
            <h4 class="text-lg font-semibold m-0 mb-1 text-gray-900 flex items-center">
              <i class="pi pi-building mr-2"></i>
              {{result.businessName}}
            </h4>
            <p class="m-0 text-sm text-gray-600 flex items-start" *ngIf="result.formattedAddress">
              <i class="pi pi-map-marker mr-2 mt-0.5"></i>
              {{result.formattedAddress}}
            </p>
          </div>

          <!-- Final Result: Approachable or Not -->
          <div class="mb-4 p-4 rounded-lg border-2" [ngClass]="{
                 'border-green-500 bg-green-50': getCustomerApproachableStatus(result) === 'PASS',
                 'border-red-500 bg-red-50': getCustomerApproachableStatus(result) === 'FAILED'
               }">
            <div class="flex items-center justify-between gap-3 flex-wrap">
              <div class="flex items-center gap-3">
                <i [class]="getCustomerApproachableStatus(result) === 'PASS' ? 'pi pi-check-circle text-green-600' : 'pi pi-times-circle text-red-600'" class="text-2xl"></i>
                <div>
                  <h3 class="text-lg font-bold m-0" [ngClass]="{
                        'text-green-700': getCustomerApproachableStatus(result) === 'PASS',
                        'text-red-700': getCustomerApproachableStatus(result) === 'FAILED'
                      }" i18n>
                    {{getCustomerApproachableStatus(result) === 'PASS' ? 'Approachable' : 'Not Approachable'}}
                  </h3>
                  <p class="text-sm m-0 mt-1" [ngClass]="{
                        'text-green-600': getCustomerApproachableStatus(result) === 'PASS',
                        'text-red-600': getCustomerApproachableStatus(result) === 'FAILED'
                      }">
                    {{result.territoryInfo && !result.territoryInfo.fsrHasAccess ? result.territoryInfo.accessMessage : (getCustomerApproachableStatus(result) === 'PASS' ? 'Customer is available for all selected products' : 'One or more products failed validation')}}
                  </p>
                </div>
              </div>
              <span class="inline-block px-3 py-1 text-xs font-bold uppercase rounded" [ngClass]="{
                'bg-green-600 text-white': getCustomerApproachableStatus(result) === 'PASS',
                'bg-red-600 text-white': getCustomerApproachableStatus(result) === 'FAILED'
              }">
                {{getCustomerApproachableStatus(result) === 'PASS' ? 'APPROACHABLE' : 'NOT APPROACHABLE'}}
              </span>
            </div>
          </div>

          <!-- Product List with Pass/Fail Status -->
          <div class="mb-4" *ngIf="result.productValidations && result.productValidations.length > 0">
            <h5 class="font-semibold text-gray-900 mb-3 flex items-center" i18n>
              <i class="pi pi-box mr-2"></i>Product Validation:
            </h5>
            <div class="flex flex-col gap-2">
              <div *ngFor="let validation of result.productValidations" 
                   class="p-3 rounded-lg border" 
                   [ngClass]="{
                     'border-green-300 bg-green-50': validation.status === 'CLEAR_TO_APPROACH',
                     'border-red-300 bg-red-50': validation.status !== 'CLEAR_TO_APPROACH'
                   }">
                <div class="flex items-start justify-between gap-3 flex-wrap">
                  <div class="flex-1">
                    <div class="flex items-center gap-2 mb-1">
                      <i [class]="validation.status === 'CLEAR_TO_APPROACH' ? 'pi pi-check-circle text-green-600' : 'pi pi-times-circle text-red-600'" class="text-lg"></i>
                      <span class="font-semibold text-gray-900">{{validation.productName}}</span>
                      <span class="px-2 py-0.5 rounded text-xs font-semibold uppercase" [ngClass]="{
                        'bg-green-600 text-white': validation.status === 'CLEAR_TO_APPROACH',
                        'bg-red-600 text-white': validation.status !== 'CLEAR_TO_APPROACH'
                      }">
                        {{validation.status === 'CLEAR_TO_APPROACH' ? 'PASS' : 'FAIL'}}
                      </span>
                    </div>
                    <div *ngIf="validation.status !== 'CLEAR_TO_APPROACH'" class="text-sm text-red-700 ml-7 mt-1">
                      <strong i18n>Fail Reason:</strong> {{validation.statusMessage}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="flex flex-col md:flex-row gap-3 flex-wrap mt-4">
            <p-button *ngIf="result.canRegister" label="Add Customer" icon="pi pi-plus" severity="success" size="small" (onClick)="registerCustomer(result)" class="w-full md:w-auto" i18n-label>
            </p-button>
            <div class="flex items-center gap-2 w-full md:w-auto flex-wrap">
              <p-button *ngIf="result.canView || customerCreatedSuccess" label="Create Reservation" icon="pi pi-calendar-plus" severity="warn" size="small" [disabled]="hasFailedProducts(result)" [pTooltip]="getCreateReservationTooltip(result)" tooltipPosition="top" (onClick)="createReservation(result)" class="flex-1 md:flex-none" i18n-label i18n-pTooltip>
              </p-button>
              <i *ngIf="hasFailedProducts(result)" class="pi pi-exclamation-triangle text-orange-500 text-sm" [pTooltip]="getCreateReservationTooltip(result)" tooltipPosition="top" i18n-pTooltip>
              </i>
            </div>
            <p-button *ngIf="hasFailedProducts(result)" appGlobalLoadingDisable label="Remove Failed Products & Recheck" icon="pi pi-refresh" severity="secondary" size="small" (onClick)="removeFailedProductsAndRecheck(result)" class="w-full md:w-auto" i18n-label>
            </p-button>
          </div>

          <!-- Divider between results (except last) -->
          <hr *ngIf="i < lookupResults.length - 1" class="my-4 mt-6">
        </div>
      </div>
    </p-card>
  </div>

  <!-- Empty State -->
  <div *ngIf="lookupResults.length === 0 && !loading">
    <p-card>
      <div class="text-center p-12">
        <i class="pi pi-search text-5xl text-gray-400 mb-4"></i>
        <h3 class="text-2xl font-semibold m-0 mb-2 text-gray-900" i18n>No Results Yet</h3>
        <p class="text-gray-600 m-0 mb-8 leading-relaxed" i18n>
          Search for a business or address to check customer availability
        </p>
        <div class="flex flex-col gap-4 max-w-md mx-auto text-left">
          <div class="flex items-start gap-3">
            <i class="pi pi-search text-blue-500 text-lg mt-0.5 flex-shrink-0"></i>
            <div>
              <span class="font-semibold text-gray-900" i18n>1. Search for a customer</span>
              <p class="m-0 mt-1 text-sm text-gray-600" i18n>
                Choose a lookup method (Google search, manual address, or geofence) and search for the business or location you want to check.
              </p>
            </div>
          </div>
          <div class="flex items-start gap-3">
            <i class="pi pi-shield text-blue-500 text-lg mt-0.5 flex-shrink-0"></i>
            <div>
              <span class="font-semibold text-gray-900" i18n>2. Review validation results</span>
              <p class="m-0 mt-1 text-sm text-gray-600" i18n>
                The system will check if the customer is available, verify territory access, and validate product availability. You'll see a clear status indicating if the customer is approachable.
              </p>
            </div>
          </div>
          <div class="flex items-start gap-3">
            <i class="pi pi-check-circle text-blue-500 text-lg mt-0.5 flex-shrink-0"></i>
            <div>
              <span class="font-semibold text-gray-900" i18n>3. Take action</span>
              <p class="m-0 mt-1 text-sm text-gray-600" i18n>
                Based on the results, you can register a new customer, create a reservation, or view existing customer details if they're already in the system.
              </p>
            </div>
          </div>
        </div>
      </div>
    </p-card>
  </div>

  <!-- Add Customer Drawer -->
  <p-drawer [(visible)]="showAddCustomerDrawer" position="right" styleClass="!w-full md:!w-[30rem] lg:!w-[60rem]" [modal]="true" (onHide)="onDrawerClose()">

    <ng-template #header>
      <div class="flex align-items-center gap-2">
        <!-- <i class="pi pi-plus text-xl"></i>
        <span class="font-bold text-xl">Add New Customer</span> -->
      </div>
    </ng-template>

    <div class="" *ngIf="selectedLookupResult">
      <app-add-edit-customer [isDrawerMode]="true" [prefilledData]="selectedLookupResult" (customerCreated)="onCustomerCreated($event)" (cancelled)="onDrawerClose()">
      </app-add-edit-customer>
    </div>
  </p-drawer>

  <!-- Toast for notifications -->
  <p-toast></p-toast>
  
  <!-- Post-Creation Dialog -->
  <p-dialog 
    [(visible)]="showPostCreationDialog" 
    [modal]="true" 
    [closable]="false"
    [style]="{width: '450px'}"
    styleClass="p-fluid">
    <ng-template #header>
      <h3 class="text-lg font-semibold m-0" i18n>Customer Created Successfully</h3>
    </ng-template>
    
    <div class="flex flex-col gap-4">
      <div class="flex items-center gap-3">
        <i class="pi pi-check-circle text-green-500 text-3xl"></i>
        <div>
          <p class="m-0 font-medium text-gray-900" i18n>Customer has been registered successfully!</p>
          <p class="m-0 text-sm text-gray-600 mt-1" *ngIf="createdCustomerData?.businessName">
            {{createdCustomerData.businessName}}
          </p>
        </div>
      </div>
      
      <div class="bg-blue-50 border border-blue-200 rounded-lg p-3">
        <p class="m-0 text-sm text-blue-800" i18n>
          What would you like to do next?
        </p>
      </div>
    </div>
    
    <ng-template #footer>
      <div class="flex gap-3 w-full">
        <p-button 
          label="Create Reservation" 
          icon="pi pi-calendar-plus"
          severity="success"
          (onClick)="onPostCreationCreateReservation()"
          [style]="{flex: '1'}"
          i18n-label>
        </p-button>
        <p-button 
          label="Proceed without Reservation" 
          icon="pi pi-arrow-right"
          severity="secondary"
          (onClick)="onPostCreationProceedWithoutReservation()"
          [style]="{flex: '1'}"
          i18n-label>
        </p-button>
      </div>
    </ng-template>
  </p-dialog>
</div>